import { topolTemplateSchema } from "@/schemas/templateSchema";
import { validateAndFixMjml } from "@/utils/validateAndFixMjml";
import { migrateApiBlocksInTree } from "./migrateApiBlocks";
import Bugsnag from "@bugsnag/js";

export function validateAndFixMjmlByZod(mjml: any) {
  // Remove undefined values
  mjml = removeUndefinedValues(mjml);
  mjml = migrateApiBlocksInTree(mjml);

  const result = topolTemplateSchema.safeParse(mjml);
  if (result.success) {
    return removeUndefinedValues(result.data);
  } else {
    const errors = result.error.issues;
    errors.forEach((error: any) => {
      const fixingPath: any = [];
      let brokenProp = mjml;

      error.path.forEach((path: string, index: number) => {
        if (index === error.path.length - 1) {
          if (error.code === "invalid_value") fixingPath.push(error.values[0]);
          if (error.code === "invalid_type") {
            fixingPath.push(undefined);
          }
        } else {
          brokenProp = brokenProp[path];
          fixingPath.push(brokenProp);
        }
      });

      for (let i = fixingPath.length - 2; i >= 0; i--) {
        const errorPath = error.path[i + 1];
        fixingPath[i][errorPath] = fixingPath[i + 1];
      }

      mjml[error.path[0]] = fixingPath[0];
    });

    mjml = removeUndefinedValues(mjml);

    const fixedResult = topolTemplateSchema.safeParse(mjml);
    if (fixedResult.success) {
      return removeUndefinedValues(fixedResult.data);
    } else {
      console.error(fixedResult.error.issues);
      Bugsnag.notify(new Error("Totaly broken template"), function (event) {
        event.addMetadata("errros", errors);
      });
    }
    return validateAndFixMjml(mjml);
  }
}

function removeUndefinedValues(mjml: any) {
  const removedMjml = mjml;
  removedMjml.children[0].children.forEach((section: any, sIndex: number) => {
    if (section === undefined) {
      removedMjml.children[0].children.splice(sIndex, 1);
      return;
    }
    if (section.children === undefined) {
      section.children = [];
    }
    section.children.forEach((column: any, cIndex: number) => {
      if (column === undefined) {
        removedMjml.children[0].children[sIndex].children.splice(cIndex, 1);
        return;
      }
      if (column.children === undefined) {
        column.children = [];
      }
      column.children.forEach((block: any, bIndex: number) => {
        if (block === undefined) {
          removedMjml.children[0].children[sIndex].children[
            cIndex
          ].children.splice(bIndex, 1);
          return;
        }
        if (block.children) {
          block.children.forEach((element: any, index: number) => {
            if (element === undefined) {
              removedMjml.children[0].children[sIndex].children[
                cIndex
              ].children[bIndex].children.splice(index, 1);
              return;
            }
          });
        }
      });
    });
  });
  return removedMjml;
}
